/*
  const callback = () => {}
  Events.on('addFavoriteTeam', callback)
  Events.off('addFavoriteTeam', callback);

  Events.on(
    [
      'addFavoriteTeam',
      'removeFavoriteTeam',
    ],
    (data) => {
      // do something width data
    },
  );
  Events.off('addFavoriteTeam', true);

  Events.emit('addFavoriteTeam', data);
*/

const events = {};
const subscribers = {};

export const Events = {
  on: (eventNames, fn) => {
    let _eventNames = eventNames;
    if (!Array.isArray(eventNames)) {
      _eventNames = [eventNames];
    }

    _eventNames.forEach(event => {
      events[event] = events[event] || [];
      events[event].push(fn);
    });
  },
  off: (eventNames, fn) => {
    let _eventNames = eventNames;
    if (!Array.isArray(eventNames)) {
      _eventNames = [eventNames];
    }

    _eventNames.forEach(eventName => {
      if (events[eventName]) {
        for (let i = 0; i < events[eventName].length; i += 1) {
          if (events[eventName][i] === fn || fn === true) {
            events[eventName].splice(i, 1);
            break;
          }
        }
      }
    });
  },
  emit: (eventName, data?: any) => {
    // console.log(`:: EVENTS.emit ::: ${eventName}`);
    if (events[eventName]) {
      events[eventName].forEach(fn => {
        fn(data);
      });
    }
  },
  subscribe: (eventName, fn) => {
    const callback = () => {
      fn();
    };
    return () => {
      if (subscribers[eventName]) {
        for (let i = 0; i < subscribers[eventName].length; i += 1) {
          if (subscribers[eventName][i] === callback) {
            subscribers[eventName].splice(i, 1);
            break;
          }
        }
      }
    };
  },
};
